// extracted by mini-css-extract-plugin
module.exports = {"container":"Components_container__jc2Jv","header":"Components_header__1gDDR"};